import { render } from "./StageRoute.vue?vue&type=template&id=eeed11f4&scoped=true"
import script from "./StageRoute.vue?vue&type=script&lang=js"
export * from "./StageRoute.vue?vue&type=script&lang=js"

import "./StageRoute.vue?vue&type=style&index=0&id=eeed11f4&scoped=true&lang=css"

import exportComponent from "/home/vueltaciclista/app/client/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-eeed11f4"]])

export default __exports__